module.exports = __webpack_public_path__ + "img/ownership.46a67981.svg";